import { Timestamp } from "@angular/fire/firestore";
import { Game } from "./game";
import { Player } from "./player";
import { GameDetail } from "./game-detail";

export interface Match {
    id?: string;
    code?: string;
    tournamentId: string;
    category?: string;
    groupName?: string;
    date?: Date;
    player1Id?: string;
    player1GamesWon?: number;
    player1GamesLost?: number;
    player1PointsWon?: number;
    player1PointsLost?: number;
    player2Id?: string;
    player2GamesWon?: number;
    player2GamesLost?: number;
    player2PointsWon?: number;
    player2PointsLost?: number;
    games: Game[];
    court?: string;
    playerIdWinner?: string | null;
    state: MatchState;

    // NUEVOS CAMPOS PARA ARBITRAJE

    // Timestamps del partido
    matchStartedAt?: Timestamp;         // Cuándo comenzó (después de warmup)
    matchEndedAt?: Timestamp;           // Cuándo terminó
    matchDurationSeconds?: number;      // Duración total en segundos

    // Configuración de timers (configurables por torneo)
    warmupSeconds?: number;             // Default: 300 (5 min)
    restBetweenGamesSeconds?: number;   // Default: 120 (2 min)

    // Configuración de formato del partido
    bestOf?: number;                    // Mejor de N juegos: 3 o 5 (default: 3)
    pointsToWin?: number;              // Puntos para ganar un juego (default: 11)

    // Información del árbitro
    refereeName?: string;               // Nombre del árbitro

    // Juegos con detalle completo (se guarda al finalizar)
    gamesDetailed?: GameDetail[];       // Array completo con eventos
}

export interface MatchExtended extends Match {
    player1?: Player;
    player2?: Player;    
}

export interface MatchByDay {
    date?: Date;
    matches: MatchExtended[];
}

export enum MatchState {
    PROGRAMADO = "PROGRAMADO",
    EN_CANCHA = "EN_CANCHA",
    JUGANDO = "JUGANDO",
    FINALIZADO = "FINALIZADO",
    CANCELADO = "CANCELADO"
}